module.exports = __webpack_public_path__ + "img/about_bg.a4aa91c2.png";